'use client';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { UpgradePrompt } from './UpgradePrompt';
import { useNeedsUpgrade } from '../model/subscription.selectors';

interface SubscriptionGateProps {
  feature: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
  onRestricted?: () => void;
}

export function SubscriptionGate({
  feature,
  fallback,
  children,
  onRestricted,
}: SubscriptionGateProps) {
  const t = useTranslations('upgradePrompt');
  const needsUpgrade = useNeedsUpgrade();
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);

  const isRestricted = needsUpgrade(feature);

  React.useEffect(() => {
    if (isRestricted && onRestricted) {
      onRestricted();
    }
  }, [isRestricted, onRestricted]);

  if (isRestricted) {
    if (fallback) {
      return (
        <>
          {fallback}
          <UpgradePrompt
            isOpen={showUpgradePrompt}
            onClose={() => setShowUpgradePrompt(false)}
            title={t('title')}
            message={t('featureRequiresUpgrade')}
            feature={feature}
          />
        </>
      );
    }
    return null;
  }

  return <>{children}</>;
}
